import operateAttrProps from "../config/operate";

/**处理区域门店数据
 * [
 *  {region: 北培, KPI: 钻石业绩, Today: 123, MTD: 123, YTD: 123},
 *  {region: 成都, KPI: 素金业绩, Today: 123, MTD: 123, YTD: 123},
 * ]
 *
 * ==>
 *
 * regionList: [北培， 成都]
 * todayList: [zs: 123, sj: 123]
 * mtdList: [zs: 123, sj: 123]
 * ytdList: [zs: 123, sj: 123]
 *
 * */
export function formatRegionList(rows) {
  let obj = {};
  let regionList = [];
  rows.forEach((v, i) => {
    // 过滤掉区域数据
    if (v.Region === v.Shop) return;
    let key = operateAttrProps[v.KPI] || v.KPI;
    if (!key) return;
    if (obj[v.Shop]) {
      obj[v.Shop].today[key] = v.Today;
      obj[v.Shop].mtd[key] = v.MTD;
      obj[v.Shop].ytd[key] = v.YTD;
    } else {
      obj[v.Shop] = {
        today: {
          [key]: v.Today,
        },
        mtd: {
          [key]: v.MTD,
        },
        ytd: {
          [key]: v.YTD,
        },
      };
      regionList.push({
        region: v.Region,
        shop: v.Shop,
        id: i + 1,
        name: v.Shop,
      });
    }
  });
  let todayList = [];
  let mtdList = [];
  let ytdList = [];
  Object.keys(obj).forEach((v, i) => {
    todayList.push({ regionId: i + 1, region: v, ...obj[v].today });
    mtdList.push({ regionId: i + 1, region: v, ...obj[v].mtd });
    ytdList.push({ regionId: i + 1, region: v, ...obj[v].ytd });
  });
  return { regionList, tableData: [todayList, mtdList, ytdList] };
}
